// extracted by mini-css-extract-plugin
export default {"spinner":"spinner--fTH82","rotate":"rotate--C4PXz","link":"link--oPRZ0","icon":"icon--I3ieW","iconWithCaption":"iconWithCaption--wDIEx","caption":"caption--bq2f6"};